import { useMemo } from 'react';
import TEXT from './generated/TEXT/useExportSettingsValidation';

TEXT.DEFINE({
  /** Validation error when no Frame.io folder / project is selected for upload */
  mustBeInProject:
    'Must select a Frame.io folder or be in a Frame.io project to export',
  /** Validation error when "save a local copy" is on but no local folder is chosen */
  mustSelectLocation: 'Must select a location on your computer to save a copy',
});

type ValidatableSettings = {
  assetFolderId?: string | null;
  localCopyEnabled?: boolean | null;
  localFolderPath?: string | null;
};

/**
 * Validates the base export-settings shape shared by all hosts (Premiere, AE).
 * Returns a localized message string ready to display, or undefined when valid.
 * Host-specific checks (e.g. active document, presets) stay in the caller.
 */
export const useExportSettingsValidation = ({
  assetFolderId,
  localCopyEnabled,
  localFolderPath,
}: ValidatableSettings): string | undefined => {
  return useMemo(() => {
    if (!assetFolderId) {
      return TEXT.mustBeInProject;
    }
    if (localCopyEnabled && !localFolderPath) {
      return TEXT.mustSelectLocation;
    }
    return undefined;
  }, [assetFolderId, localCopyEnabled, localFolderPath]);
};
